export const API_ERROR_CODES = {
    VALIDATION: 'E_VALIDATION',
    UNAUTHENTICATED: 'E_UNAUTHENTICATED',
    FORBIDDEN: 'E_FORBIDDEN',
    NOT_FOUND: 'E_NOT_FOUND',
    CONFLICT: 'E_CONFLICT',
    TOO_MANY_REQUESTS: 'E_TOO_MANY_REQUESTS',
    IDEMPOTENCY_IN_PROGRESS: 'E_IDEMPOTENCY_IN_PROGRESS',
    IDEMPOTENCY_MISMATCH: 'E_IDEMPOTENCY_MISMATCH',
    INTERNAL: 'E_INTERNAL',
};
export const API_PREFIX = '/api/v1';
export const REQUEST_ID_HEADER = 'x-request-id';
export const IDEMPOTENCY_HEADER = 'idempotency-key';
export const PERM_VERSION_HEADER = 'x-perm-version';
//# sourceMappingURL=api.js.map